export const hasCounter = counter => typeof counter !== 'undefined';